<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="resize">
<g id="Vector">
<path d="M13.9024 2.56904C14.0325 2.43886 14.0325 2.22781 13.9024 2.09763C13.7722 1.96746 13.5611 1.96746 13.431 2.09763L2.09763 13.4309C1.96746 13.5611 1.96746 13.7721 2.09763 13.9023C2.2278 14.0325 2.43886 14.0325 2.56903 13.9023L13.9024 2.56904Z" fill="#254B86"/>
<path d="M13.8942 7.23397C14.0244 7.10379 14.0244 6.89274 13.8942 6.76256C13.7641 6.63239 13.553 6.63239 13.4228 6.76256L6.75616 13.4292C6.62599 13.5594 6.62599 13.7704 6.75616 13.9006C6.88633 14.0308 7.09739 14.0308 7.22756 13.9006L13.8942 7.23397Z" fill="#254B86"/>
</g>
</g>
</svg>
